import { collection, doc, documentId, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from './firebase';
import { CHAT_COLLECTION } from '../config/runtime';
import { createArtifactTemplateMetadataResolver } from '../utils/artifactTemplateMetadata';

export function createChatArtifactTemplateResolver(uid: string, chatId: string) {
  return createArtifactTemplateMetadataResolver(uid, chatId, {
    async readArtifacts(ids) {
      const snapshot = await getDocs(query(collection(db, CHAT_COLLECTION, chatId, 'artifacts'), where(documentId(), 'in', ids)));
      return new Map(snapshot.docs.map(record => [record.id, record.data()]));
    },
    async readSource(path) {
      const snapshot = await getDoc(doc(db, path));
      return snapshot.exists() ? snapshot.data() : null;
    }
  });
}
